import { useCallback, useState } from "react"
import { CreateCreditNoteDialog } from "./CreateCreditNoteDialog"

type CreditNoteDialogState = Readonly<{
    open: boolean
    id: number
}>

export type UseCreditNoteDialogResult = Readonly<{
    showCreditNoteModal: CreditNoteDialogState | null
    openCreditNoteDialog: (orderId: number) => void
    closeCreditNoteDialog: () => void
    creditNoteDialog: JSX.Element | null
}>

export function useCreditNoteDialog(): UseCreditNoteDialogResult {
    const [showCreditNoteModal, setShowCreditNoteModal] = useState<CreditNoteDialogState | null>(null)

    const openCreditNoteDialog = useCallback((orderId: number) => {
        setShowCreditNoteModal({
            open: true,
            id: orderId,
        })
    }, [])

    const closeCreditNoteDialog = useCallback(() => {
        setShowCreditNoteModal(null)
    }, [])

    const creditNoteDialog =
        showCreditNoteModal && showCreditNoteModal.open ? (
            <CreateCreditNoteDialog
                open={showCreditNoteModal.open}
                orderId={showCreditNoteModal.id}
                onClose={closeCreditNoteDialog}
            />
        ) : null

    return {
        showCreditNoteModal,
        openCreditNoteDialog,
        closeCreditNoteDialog,
        creditNoteDialog,
    }
}
